import type { ContactDetails } from '@highereducation/prospect';
import type { SaveContactParams } from '@de/types';
/**
 * Maps DE lead data to Prospect Service `ContactDetailsDto` (whitelist only).
 * @see prospect-service `application/src/v1/prospect/prospect.dto.ts`
 */
export function buildProspectContactDetails(
  data: SaveContactParams,
): ContactDetails {
  const lead = data.lead;
  const details: ContactDetails = {
    category: data.category,
    degree: data.degree,
    subject: data.subject,
  };

  assignOptionalDetail(details, 'lastName', lead.lastName);
  assignOptionalDetail(details, 'email', lead.email);
  assignOptionalDetail(details, 'phoneNumber', lead.phoneNumber);
  assignOptionalDetail(details, 'hsGradYear', lead.hsGradYear);
  assignOptionalDetail(details, 'levelOfEducation', lead.levelOfEducation);
  assignOptionalDetail(details, 'militaryStatus', lead.militaryStatus);
  assignOptionalDetail(details, 'startDate', lead.startDate ?? undefined);
  assignOptionalDetail(details, 'tcpaText', lead.tcpaText);
  assignOptionalDetail(details, 'thirdPartyLeadId', lead.thirdPartyLeadId);
  assignOptionalDetail(details, 'currentLicense', lead.currentLicense);
  assignOptionalDetail(
    details,
    'hasGivenTCPAConsent',
    lead.hasGivenTCPAConsent,
  );
  assignOptionalDetail(
    details,
    'hasGivenThirdPartySharingConsent',
    lead.hasGivenThirdPartySharingConsent,
  );
  assignOptionalDetail(
    details,
    'hasGivenProspectSharingConsent',
    lead.hasGivenProspectSharingConsent,
  );
  assignOptionalDetail(
    details,
    'currentPermanentResidenceCountry',
    lead.currentPermanentResidenceCountry ?? undefined,
  );
  assignOptionalDetail(details, 'leadSource', lead.leadSource ?? undefined);

  const postalCode = lead.location?.postalCode?.trim();
  if (postalCode) {
    details.location = {
      postalCode,
      country: lead.location?.country?.trim() || 'US',
      ipInferredPostalCode:
        lead.location?.ipInferredPostalCode?.trim() || postalCode,
    };
  }

  return details;
}

function assignOptionalDetail<K extends keyof ContactDetails>(
  details: ContactDetails,
  key: K,
  value: ContactDetails[K] | null | undefined,
): void {
  if (value !== undefined && value !== null && value !== '') {
    details[key] = value;
  }
}
